import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmAttachmentsApi } from './types';

export const emAttachments: TEmAttachmentsApi = {
	getTypes: () => http.get(endpoint.attachments.GET_TYPES).then(r => r.data),
	getList: (emId: number) => http.get(endpoint.attachments.LIST(emId)).then(r => r.data),
	download: ({ emId, attachmentId }) =>
		http
			.get(endpoint.attachments.GET_ONE(emId, attachmentId), { responseType: 'blob' })
			.then(r => r.data),
	delete: ({ emId, attachmentId }) =>
		http.delete(endpoint.attachments.DELETE(emId, attachmentId)).then(() => {}),
	upload: payload =>
		http.post(endpoint.attachments.UPLOAD(payload.emId), payload.formData).then(() => {}),
	getOne: payload =>
		http
			.get(endpoint.attachments.GET_ONE(payload.emId, payload.attachmentId), {
				responseType: 'blob',
			})
			.then(r => r.data),
	generateUploadLink: payload =>
		http
			.post(endpoint.attachments.UPLOAD_LINKS(payload.emId), {
				typeId: payload.typeId,
				operatorsEmails: payload.operatorsEmails,
				comment: payload.comment ?? '',
			})
			.then(r => r.data),
};
